const FGLOBAL = new Map();

export { FGLOBAL };